<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="项目详情"
    :show-close="true"
    :visible="true"
    :modal="false"
    :before-close="handleBeforeClose"
    width="900px"
  >
    <div class="dialog__container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="电梯信息" name="dtxx">
          <DTXX :projectId="projectId"></DTXX>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>


import DTXX from '../../xmgl/components/DetailProoject/dtxx'

export default {
  components: {
    DTXX
  },
  data() {
    return {
      activeName: "dtxx",
    };
  },

  props: ["projectId"],

  created() {

  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/dxjh/components/DetailProoject.vue